<div class="timeline-container">
    <div *ngFor="let status of statusesToShow" class="step">
        <div class="step-icon-container">
            <app-timeline-step [status]="status"></app-timeline-step>
            <app-step-separator-line [id]="status.id" [length]="statusesToShow.length"></app-step-separator-line>
        </div>
        <div class="step-content">
            <div class="grow-fix">
                <b>{{ status.name }}</b>
            </div>
            <div class="grow-fix" *ngIf="!status.future && status.comments">
                <p class="comment">{{ status.comments || '' }}</p>
            </div>

            <div class="grow-fix mt-1" *ngIf="status.justification && status.id >= 6">
                <b>Justificativa da recusa</b>
                <p class="comment">{{ status.justification || '' }}</p>
            </div>
        </div>
    </div>
</div>
